import React from "react";
import { TableColGroup } from "./TableColGroup";
export function TableBox(_a) {
    var columns = _a.columns, children = _a.children, classPrefix = _a.classPrefix, style = _a.style;
    return (React.createElement("table", { className: classPrefix + "-table__box", style: style },
        React.createElement(TableColGroup, { columns: columns }),
        children));
}
TableBox.displayName = "TableBox";
//# sourceMappingURL=TableBox.js.map